export const getHawkesBayData = () => ({
  name: "Hawke's Bay",
  country: "Nouvelle-Zélande",
  description: "Hawke's Bay est la deuxième plus grande région viticole de Nouvelle-Zélande, réputée pour ses vins rouges de qualité et ses vins blancs élégants. Située sur la côte est de l'île du Nord, la région bénéficie d'un climat chaud et sec avec des influences maritimes.",
  type: "region",
  area: "4,800 ha",
  production: "0.4 million hectolitres",
  climate: "Climat chaud et sec avec influences maritimes, étés longs et hivers doux",
  soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
  characteristics: {
    climate: "Climat chaud et sec avec influences maritimes, étés longs et hivers doux",
    soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    red: "Vins rouges structurés et fruités, avec des tanins mûrs et une excellente complexité",
    white: "Vins blancs secs et aromatiques, avec une belle acidité et des notes minérales",
    rosé: "Rosés élégants et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Hawke's Bay remonte au XIXe siècle avec les premiers vignobles commerciaux. La région a développé une réputation pour ses vins rouges de qualité, notamment le Merlot et le Cabernet Sauvignon. Aujourd'hui, Hawke's Bay est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Viandes rouges, fromages affinés, plats méditerranéens, cuisine locale",
  subregions: {
    "Gimblett Gravels": {
      name: "Gimblett Gravels",
      description: "Terroir unique avec sols de graviers, spécialisé dans les vins rouges",
      area: "800 ha",
      characteristics: "Sols de graviers, climat chaud, vins rouges puissants",
      grapeVarieties: ["merlot", "cabernet-sauvignon", "syrah", "chardonnay"]
    },
    "Bridge Pa": {
      name: "Bridge Pa",
      description: "Plateau viticole produisant des vins rouges et blancs de qualité",
      area: "600 ha",
      characteristics: "Sols argileux, climat tempéré, vins équilibrés",
      grapeVarieties: ["merlot", "syrah", "chardonnay", "sauvignon-blanc"]
    },
    "Havelock North": {
      name: "Havelock North",
      description: "Zone viticole traditionnelle avec des vignobles établis",
      area: "400 ha",
      characteristics: "Sols calcaires, microclimats, vins élégants",
      grapeVarieties: ["chardonnay", "sauvignon-blanc", "merlot", "pinot-noir"]
    }
  },
  grapeVarieties: [
    {
      name: "Merlot",
      percentage: "35%",
      description: "Cépage rouge principal, produisant des vins structurés et fruités",
      characteristics: "Structuré, fruité, tanins mûrs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Chardonnay",
      percentage: "25%",
      description: "Cépage blanc principal, produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "20%",
      description: "Cépage blanc produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Syrah",
      percentage: "10%",
      description: "Cépage rouge produisant des vins élégants et épicés",
      characteristics: "Élégant, épicé, tanins fins",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Autres",
      percentage: "10%",
      description: "Autres cépages incluant Cabernet Sauvignon, Pinot Noir et cépages blancs",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Gimblett Gravels", x: 176.8, y: -39.5, color: "#4B164C", size: 5 },
    { region: "Bridge Pa", x: 176.6, y: -39.6, color: "#6d2c7a", size: 4 },
    { region: "Havelock North", x: 176.9, y: -39.7, color: "#8a4a8a", size: 3 }
  ]
}); 